import { DOMAIN, LoggerFactory } from 'Services/Logger';
import { ifProd } from 'Utils/env';

import * as Providers from './featureFlagProviders';
import { MIN_PRIORITY, MEDIUM_PRIORITY, MAX_PRIORITY } from './constants';
import FeatureFlagService from './FeatureFlagService';

const logger = LoggerFactory.getLogger(DOMAIN.AMON);

/* Providers initialization */

const envProvider = new Providers.EnvFeatureFlagProvider(MIN_PRIORITY);
const localStorageProvider = new Providers.LocalStorageFeatureFlagProvider(
  ifProd(MEDIUM_PRIORITY, MAX_PRIORITY),
);
const remoteProvider = new Providers.RemoteFeatureFlagProvider(
  ifProd(MAX_PRIORITY, MEDIUM_PRIORITY),
  logger,
);

const remoteConsumerEnablementProvider = new Providers.RemoteConsumerEnablementProvider(
  ifProd(MAX_PRIORITY, MEDIUM_PRIORITY),
  logger,
);

const ldProvider = new Providers.LaunchDarklyFeatureFlagProvider(
  ifProd(MAX_PRIORITY, MEDIUM_PRIORITY),
  logger,
);

FeatureFlagService.addProviders(
  envProvider,
  localStorageProvider,
  remoteProvider,
  remoteConsumerEnablementProvider,
  ldProvider,
);

export default FeatureFlagService;
